import serializeForm from 'form-serialize';
import { enableForm } from './form-submit';
import { createMessageContainer, hideMessages, showMessage } from './form-notification';

const forms = document.querySelectorAll('form');

function handleAjaxSubmit(form, options = {}) {
	const messages = createMessageContainer(form);
	let isCollapsing = false;

	form.addEventListener('submit', event => {
		event.preventDefault();

		// Return if request is running already
		// if (form.classList.contains('is-loading')) {
		// 	return;
		// }

		setTimeout(() => {
			// Return if there are validation issues
			if (form.querySelector('[aria-invalid="true"]')) {
				return;
			}

			const url = form.getAttribute('action');
			let formData = serializeForm(form, {
				hash: true
			});

			// Hide messages
			isCollapsing = hideMessages(messages, isCollapsing);

			// Handle wizard
			let wizard = form.closest('[data-init="wizard"]');

			if (wizard) {
				wizard = window.moduleInstances[wizard.dataset.wizard];

				// Optionally add data from previous steps to payload
				if (options.includeWizard) {
					wizard.steps.slice(0, wizard.activeStep).forEach(step => {
						const forms = step.querySelectorAll('form');

						forms.forEach(form => {
							// Skip inactive tab panels
							if (form.closest('.ln-wizard__panel:not(.is-active')) {
								return;
							}

							const stepData = serializeForm(form, {
								hash: true
							});

							formData = Object.assign(stepData, formData);
						});
					});
				}
			}

			fetch(url, {
				method: 'POST',
				credentials: 'same-origin',
				body: JSON.stringify(formData),
				headers: {
					'Content-Type': 'application/json',
					'X-Requested-With': 'XMLHttpRequest'
				}
			})
				.then(response => response.json())
				.then(data => {
					enableForm(form);

					if (data.error) {
						// Navigate to specific wizard step if necessary
						if (wizard && data.step !== undefined) {
							wizard.activate(data.step);
						}

						throw new Error(data.error);
					}

					if (data._csrf) {
						document.querySelectorAll('input[name="_csrf"]').forEach(field => {
							field.value = data._csrf;
						});
					}

					if (!wizard) {
						showMessage(messages, data.success, {
							isCollapsing
						});
					} else if (data.redirect) {
						window.location.href = data.redirect;
					} else {
						wizard.next();

						if (data.info) {
							wizard.showMessage({
								message: data.info
							});
						}
					}
				})
				.catch(err => {
					enableForm(form);

					if (wizard) {
						wizard.showMessage({
							message: err.message,
							error: true
						});
					} else {
						showMessage(messages, err.message, {
							error: true,
							isCollapsing
						});
					}
				});
		});
	});
}

forms.forEach(form => {
	const options = (form.dataset.formOptions ? JSON.parse(form.dataset.formOptions) : null) || {};

	// Ajax submit
	if (options.ajax) {
		handleAjaxSubmit(form, options);
	}
});
